import fileDownload from 'react-file-download';

import { request } from './common';

export type JetstarBspImportCounters = {
  totalRows: number;
  totalPnrs: number;
  successPnrs: number;
  failedPnrs: number;
};

export type JetstarBspImportStatus = {
  importId: string;
  status: 'pending' | 'processing' | 'completed' | 'completed_with_errors' | 'failed';
  counters: JetstarBspImportCounters;
  counts?: {
    totalRows: number;
    totalPnrs: number;
    completedPnrs: number;
    successPnrs: number;
    failedPnrs: number;
    skippedRows: number;
  };
  masterJobId?: string | null;
  createdAt?: string;
  updatedAt?: string;
};

export type JetstarBspImportResultItem = {
  pnr: string;
  status: 'pending' | 'processing' | 'success' | 'failed';
  reasonCode?: string;
  reasonMessage?: string;
  orderNumber?: string;
  processedAt?: string;
};

export type JetstarBspImportResultsResponse = {
  importId: string;
  status: JetstarBspImportStatus['status'];
  counters: JetstarBspImportCounters;
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    hasMore: boolean;
  };
  results: Array<JetstarBspImportResultItem>;
};

type CreateImportResponse = {
  importId: string;
  status: string;
  statusEndpoint: string;
  resultsEndpoint: string;
  errorsCsvEndpoint: string;
};

function basePath() {
  return `${window.configs.API_HOST}/api/reporting/travel-operations/jetstar-bsp/imports`;
}

class JetstarBspService {
  static async uploadImport(file: File): Promise<CreateImportResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return request(basePath(), {
      method: 'POST',
      body: formData,
    });
  }

  static async getImportStatus(importId: string): Promise<JetstarBspImportStatus> {
    return request(`${basePath()}/${importId}/status`, { method: 'GET' });
  }

  static async getImportResults(
    importId: string,
    page: number,
    pageSize: number,
  ): Promise<JetstarBspImportResultsResponse> {
    const queryParams = new URLSearchParams({
      page: `${page}`,
      pageSize: `${pageSize}`,
    });

    return request(`${basePath()}/${importId}/results?${queryParams.toString()}`, { method: 'GET' });
  }

  static async downloadImportErrorsCsv(importId: string): Promise<void> {
    const csvData = await request(`${basePath()}/${importId}/errors.csv`, {
      method: 'GET',
      download: true,
    });

    await fileDownload(csvData, `jetstar-bsp-import-${importId}-errors.csv`);
  }
}

export default JetstarBspService;
